export default __webpack_public_path__ + "bedcaaaeb8b861b33351604ffd2d5dec.svg";